import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthQueryKeys } from 'services/auth/queries/constants';
import {
  BaseResponseEntity,
  Disable2faDto,
  UserWalletAuthService,
} from 'services/openapi';
import { UserServiceQueryKeys } from 'services/user/constants';

export const useDisableTwoFaMutation = () => {
  const queryClient = useQueryClient();
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<BaseResponseEntity, Error, Disable2faDto>({
      mutationFn: (variables: Disable2faDto) =>
        UserWalletAuthService.authControllerDisableTwoFa(variables),
      onSuccess: () =>
        Promise.all([
          queryClient.invalidateQueries([AuthQueryKeys.GET_TWO_FA_STATUS]),
          queryClient.invalidateQueries([
            UserServiceQueryKeys.GET_USER_PROFILE,
          ]),
        ]),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
